function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { euiFormControlSize } from '../form.styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "nbwcci-fullWidth",
  styles: "max-inline-size:100%;label:fullWidth;"
} : {
  name: "nbwcci-fullWidth",
  styles: "max-inline-size:100%;label:fullWidth;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "9gg6o0-euiRangeWrapper",
  styles: "display:flex;align-items:center;>.euiFormControlLayout{inline-size:auto;max-inline-size:50%;.euiFormControlLayout__childrenWrapper{flex-shrink:0;}.euiFormControlLayout__prepend,.euiFormControlLayout__append{flex-shrink:1;max-inline-size:none;}};label:euiRangeWrapper;"
} : {
  name: "9gg6o0-euiRangeWrapper",
  styles: "display:flex;align-items:center;>.euiFormControlLayout{inline-size:auto;max-inline-size:50%;.euiFormControlLayout__childrenWrapper{flex-shrink:0;}.euiFormControlLayout__prepend,.euiFormControlLayout__append{flex-shrink:1;max-inline-size:none;}};label:euiRangeWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiRangeWrapperStyles = function euiRangeWrapperStyles(euiThemeContext) {
  return {
    euiRangeWrapper: _ref2,
    regular: /*#__PURE__*/css(euiFormControlSize(euiThemeContext), ";;label:regular;"),
    compressed: /*#__PURE__*/css(euiFormControlSize(euiThemeContext, {
      compressed: true
    }), ";;label:compressed;"),
    fullWidth: _ref
  };
};